import * as React from 'react';
import classNames from 'classnames';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyLabel = styled('span', {
    name: 'StyLabel',
})({
    whiteSpace: 'nowrap',
    fontSize: '0.83rem',
});

const StyButton = styled(Button, {
    name: 'StyButton',
})({
    marginBottom: '1.5rem',
});

type SideButtonProps = {
    icon?: React.ReactNode;
    text: React.ReactNode;
    className?: string;
    onClick?: (arg1: React.SyntheticEvent<HTMLButtonElement>) => void;
    to?: string;
    href?: string;
    children?: JSX.Element;
};

const SideButton = ({
    icon = undefined,
    text,
    className = '',
    onClick = () => {},
    to = '',
    href = '',
    children = undefined,
}: SideButtonProps): React.ReactElement => {
    const button = (
        <StyButton
            className={classNames(className)}
            onClick={onClick}
            startIcon={icon}
        >
            <StyLabel>{text}</StyLabel>
            <Box sx={{ ml: 'auto', display: 'inline-flex' }}>{children}</Box>
        </StyButton>
    );
    if (to) {
        return <Link to={to}>{button}</Link>;
    }
    if (href) {
        return <a href={href}>{button}</a>;
    }
    return button;
};

export { SideButton };
